import styled from 'styled-components';
import colors from "common/theme/saasModern/colors"
import { saasModernTheme } from 'common/theme/saasModern';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-sizing: content-box;
  margin-bottom: 10px;
  padding-top: 6rem;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  position: relative;
  @media (min-width: 1150px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(to right bottom, rgba(255, 255, 255, 0.1), transparent  , transparent, transparent, transparent);
  padding: 56px;
  border-radius: 64px;
  @media (max-width: 950px) {
  padding: 56px 0;
background: none;
  }
`;

export const Heading = styled.h2`
  font-family: ${saasModernTheme.fontFamily};
  font-size: 3rem;
  font-weight: 900;
  margin: 0;
  transition: 500ms;
  @media (max-width: 1440px) {
    font-size: 3rem;
  }
  @media (max-width: 950px) {
    font-size: 2rem;
  }
`

export const GradientText = styled.span`
  background: linear-gradient(to right, #3b82f6, #ec4899, #f97316);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`

export const Description = styled.div`
  color: ${colors.black};
  font-size: 1.5rem;
  font-weight: 300;
  font-family: ${saasModernTheme.fontFamily};
`;

export const SocialSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SocialTitle = styled.h3`
  color: black;
  font-size: 1.25rem;
  font-family: ${saasModernTheme.fontFamily};
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1.5rem;
`;

export const SocialIcon = styled.a`
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
`;

export const RightSection = styled.div`
  position: relative;
`;

export const FormBackground = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  width: 16rem;
  height: 16rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  filter: blur(100px);
  z-index: -1;
`;

export const FormBackground2 = styled(FormBackground)`
  bottom: 0;
  left: 50%;
  background-color: rgba(249, 115, 22, 0.2);
`;

export const Form = styled.form`
  backdrop-filter: blur(10px);
  border-radius: 1.5rem;
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  :hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }
`;

export const InputGroup = styled.div`
  display: grid;
  gap: 1.5rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

`;

export const Label = styled.label`
  font-family: ${saasModernTheme.fontFamily};
  color: black;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const Required = styled.span`
  color: #F87171;
`;

export const Input = styled.input`
  background-color: transparent;
  font-family: ${saasModernTheme.fontFamily};
  border: 1px solid gray;
  border-radius: 0.9rem;
  padding: 0.5rem 1rem;
  color: black;
  font-size: 1rem;
  height: 2.3rem;
  &::placeholder {
    color: gray;
  }
`;

export const Textarea = styled(Input).attrs({ as: 'textarea' })`
  min-height: 120px;
  resize: vertical;
`;

export const SubmitButton = styled.button`
  background: ${colors.redSecondary};
  font-family: ${saasModernTheme.fontFamily};
  color: black;
  border: none;
  border-radius: 1.6rem;
  padding: 1rem;
  font-size: 1.125rem;
  cursor: pointer;
  transition: opacity 0.3s ease;
  font-weight: 900;
  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const FormFooter = styled.p`
  font-family: ${saasModernTheme.fontFamily};
  color: #636F81;
  font-size: 0.875rem;
  font-weight: 900;
`;

 
export const BorderBottom = styled.div`
  width: 30%;
  height: 2px;
  background: #3b82f6;
  margin-top: 24px;
  background: linear-gradient(90deg, gray, gray,red);

`
